<div class="mct-flex mct-col" *ngIf="dataQueryDto != null">
  <div class="mb-20">
    <span style="font-weight: bold">{{ 'common.important' | translate | titlecase }}</span>:
    {{ 'reports.query-tool.view-sql.unlock-warning' | translate }}
  </div>
  <div class="mb-20">
    <p-checkbox [(ngModel)]="dataQueryDto.IsRawSql" binary="true" name="useCustomSQL" inputId="useCustomSQL">
    </p-checkbox>
    <label for="useCustomSQL">
      {{ 'reports.query-tool.view-sql.use-custom-sql' | translate }}
    </label>
  </div>
  <div class="w-75">
    <textarea pInputTextarea [(ngModel)]="dataQueryDto.Sql" [disabled]="!dataQueryDto.IsRawSql" rows="20"
      [ngClass]="'w-100'"> </textarea>
  </div>
</div>
